import classNames from 'classnames'
import React from 'react'
import { FlagIcon } from 'src/components/framework/icons/flag'
import { Card, Column, Grid } from 'src/components/framework/ui'
import { SectionHeader } from 'src/components/framework/ui/section-header'
import { SecurityImage } from 'src/components/framework/ui/security-image'
import { useStockReportContext } from 'src/contexts/stock-report.context'
import { makeSecurityLink } from 'src/shared/utils'

export const SimilarSecurities: React.FC = () => {
  const { report } = useStockReportContext()
  const { security } = report

  return (
    <>
      {report.similar.length && (
        <>
          <SectionHeader spacing={3}>
            Similar to {security.ticker}
          </SectionHeader>
          <Card variants={['outlined']}>
            {report.similar.map((similarSecurity, index) => (
              <Grid key={index}>
                <Column shrink={'shrink'}>
                  <SecurityImage
                    security={{
                      ...similarSecurity,
                      exchangeCode: similarSecurity.exchange.code,
                    }}
                    width={40}
                    height={40}
                  />
                </Column>
                <Column>
                  <h3 className="stk-text-h4">
                    <a
                      href={makeSecurityLink({
                        ...similarSecurity,
                        googleExchangeCode:
                          similarSecurity.exchange.googleExchangeCode,
                      })}
                    >
                      {similarSecurity.name}
                    </a>
                  </h3>
                  <p
                    className={classNames(
                      'stk-space-out-t-0',
                      'stk-text-small',
                    )}
                  >
                    <FlagIcon
                      country={similarSecurity.countryCode}
                      className={'inline-flag'}
                    />
                    {similarSecurity.exchange.name}
                  </p>
                </Column>
              </Grid>
            ))}
          </Card>
        </>
      )}
    </>
  )
}
